var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Row',{staticClass:"ly-title",class:{'ly-title__absolute': _vm.attrs.fixed}},[_c('Col',{attrs:{"span":"4"}},[_c('label',[_vm._v(_vm._s(_vm.attrs.title))])]),_vm._v(" "),_c('Col',{attrs:{"span":"20"}},[_vm._l((_vm.attrs.children),function(el){return [_c('ly-hoc',{attrs:{"attrs":el,"power":_vm.power}})]})],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9324c698","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../projectCore/src/components/title/src/index.vue
// module id = null
// module chunks = 